import React from 'react'
import EditableTable from './components/EditableTable/index.jsx'
import 'babel-polyfill';

import './index.css';

export default ()=>{
  return <EditableTable />;
}



// WEBPACK FOOTER //
// ./src/view/users/index.jsx